import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import styled from 'styled-components';

import { Tabs as TabsPattern } from '@mlb/react-patterns/components/Tabs/tabs';
import { ButtonGroupWrapper } from '@mlb/react-patterns/components/ButtonGroup/buttonGroup.style';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import { Tracking } from 'bdvp-tracking';

import useFiltersConfig from '../../../hooks/useFiltersConfig';
import TabContent from './TabContent';

const TabsWrapper = styled.div`
    visibility: ${(props) => props.hide ? 'hidden' : 'visible'};
    padding-bottom: 300px;
    ${ButtonGroupWrapper} {
        margin-left: 16px;
        ${media.lgmin`
            margin-left: 32px;
        `}
    }
`;

const Tabs = ({
    loading,
    data,
    selectedFilters,
    addSelectedFilter,
    removeSelectedFilter,
    filtersConfig,
    hide,
}) => {

    const onClickHandler = (event) => {

        const target = event.currentTarget;
        const dataName = target.getAttribute('data-name');
        const dataIndex = target.getAttribute('data-index');

        Tracking.trackFilterTabClick(dataName, dataIndex);

    };

    const firstTabName = _get(filtersConfig, '[0].name');
    const tabList = filtersConfig.map((tab, index)=> {

        return {

            ...tab,
            handlers: { onClick: onClickHandler },
            children: (
                <TabContent
                    filters={tab.filters}
                    loading={loading}
                    data={data}
                    selectedFilters={selectedFilters}
                    addSelectedFilter={addSelectedFilter}
                    removeSelectedFilter={removeSelectedFilter}
                />
            ),
            dataAttr: {
                'data-index': index,
                'data-name': tab.name,
            },

        };

    });

    return (
        <TabsWrapper hide={hide}>
            <TabsPattern
                initialActiveTab={firstTabName}
                list={tabList}
            />
        </TabsWrapper>
    );

};

Tabs.propTypes = {
    loading: PropTypes.bool.isRequired,
    data: PropTypes.object,
    selectedFilters: PropTypes.array.isRequired,
    addSelectedFilter: PropTypes.func.isRequired,
    removeSelectedFilter: PropTypes.func.isRequired,
    hide: PropTypes.bool,
    filtersConfig: PropTypes.array.isRequired,
};

Tabs.defaultProps = {
    hide: false,
    data: {},
};

export default Tabs;
